import React, { useState } from "react";
import Collapse from "react-bootstrap/esm/Collapse";
import IconLibraryEnum from "../../enums/icon-library.enum";
import IconEnum from "../../enums/icon.enum";
import ShadesEnum from "../../enums/shades.enum";
import classMap from "../../helpers/classMap";
import ButtonIcon from "../button-icon/button-icon";
import DrawerProps from "./drawer.props";
import "./drawer.scss";

const Drawer = (props: DrawerProps) => {
  const [open, setOpen] = useState(props.open);

  const isOpen = () => (props.open !== undefined ? props.open : open);

  return (
    <div
      className={classMap(
        "mpng-ux-drawer position-fixed top-0 shadow-sm",
        props.right ? "right-0" : "left-0",
        props.className
      )}
    >
      {
        // show toggle by default (when undefined)
        (props.showToggle || props.showToggle === undefined) && (
          <ButtonIcon
            {...{
              callback: () => setOpen(!open),
              priority: ShadesEnum.LIGHT,
              icon: {
                library: IconLibraryEnum.LIGHT,
                icon:
                  (!props.right && !isOpen()) || (props.right && isOpen())
                    ? IconEnum.CHEVRON_RIGHT
                    : IconEnum.CHEVRON_LEFT
              },
              className: classMap(
                "drawer-toggle mt-5 py-3",
                "position-absolute top-0",
                "animation shadow-hover",
                "bg-white z-index--1",
                props.right ? "right pr-3 pl-2" : "left pr-2 pl-3",
                props.className
              )
            }}
          />
        )
      }
      <Collapse in={isOpen()} dimension="width">
        <div className="animation">
          <div className={classMap("bg-light vh-100 p-3", `size ${props.size || "sm"}`)}>{props.child}</div>
        </div>
      </Collapse>
    </div>
  );
};

export default Drawer;
